import SelfContainedTabs from '@wix/da-shared-react/pkg/Tabs/SelfContainedTabs';
import Container from './TimePeriodSwitcher.container';

export default Container(SelfContainedTabs);
